<cmps-dialog class="cmps-coaching-bl-dialog--dialog">
    <cmps-dialog-header
        class="cmps-coaching-bl-dialog--dialog-header"
        [hasExpandAction]="true"
        [collapseTooltip]="_i18n._9978_COLLAPSE | translate"
        [expandTooltip]="_i18n._9977_EXPAND | translate"
        [closeTooltip]="_i18n._763_CLOSE | translate"
    >
        <div class="cmps-coaching-bl-dialog--focus-container">
            <span *ngIf="_service.state?.pending?.documents === true">...</span>
            <ng-container *ngIf="_service.state?.pending?.documents !== true">
                <span class="cmps-coaching-bl-dialog--behaviour-name">{{
                    _service.state?.focus?.behaviourName
                }}</span>
                <span>{{ _service.state?.focus?.subBehaviourName }}</span>
            </ng-container>
        </div>
    </cmps-dialog-header>
    <cmps-dialog-body class="cmps-coaching-bl-dialog--dialog-body">
        <cmps-coaching-bl-document
            [html]="_service.state?.documents?.[0]?.renderedHtml"
            *ngIf="_service.state?.pending?.documents !== true"
        ></cmps-coaching-bl-document>
    </cmps-dialog-body>
</cmps-dialog>
